<template>
  <div style="margin-left: 20px;margin-right: 30px;">
    <div style="font-size: 0.9rem;margin-bottom: 10px;">
      <el-row style="border-bottom: 1px solid rgba(41, 155, 255, .2);padding: 35px 0 0 0;">
        <el-col :lg="9" :md="9" :sm="15" :xl="7" :xs="24">
          <span>时间范围：</span>
          <el-date-picker
            end-placeholder="结束日期"
            format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            size="mini"
            start-placeholder="开始日期"
            style="width: 80%"
            type="datetimerange"
            v-model="screenDate"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-col>
        <el-col :lg="6" :md="6" :sm="9" :xl="5" :xs="24">
          <span>选择空间：</span>
          <el-cascader
            :options="spaceTree"
            change-on-select="true"
            clearable
            placeholder="请选择空间"
            size="mini"
            style="width: 70%"
            v-model="defaultForm.spaceIds">
          </el-cascader>
        </el-col>
        <el-col :lg="6" :md="6" :sm="9" :xl="5" :xs="12">
          <span>选择设备：</span>
          <el-select
            collapse-tags
            filterable
            multiple
            placeholder="请选择"
            size="mini"
            @change="handleSelectChange"
            style="padding-bottom: 5px;width: 70%"
            v-model="deviceIds">
            <el-option v-if="options.length > 0" value="all" label="全选">
              <el-checkbox 
                v-model="isAllSelected"
                :indeterminate="isIndeterminate" 
                @change="checkAll" 
                @click.native.stop
                style="color: #606266;"
                label="全选">
              </el-checkbox>
            </el-option>
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-for="item in options">
            </el-option>
          </el-select>
        </el-col>
        <el-col :lg="6" :md="21" :sm="15" :xl="6" :xs="12">
          <span>选择测点：</span>
          <el-select
            clearable
            collapse-tags
            filterable
            multiple
            placeholder="请选择测点"
            size="mini"
            @change="handlePointSelectChange"
            v-model="defaultForm.pointCodes">
            <el-option v-if="pointList.length > 0" value="all" label="全选">
              <el-checkbox 
                v-model="isAllPointsSelected"
                :indeterminate="isPointsIndeterminate" 
                @change="checkAllPoints" 
                @click.native.stop
                style="color: #606266;"
                label="全选">
              </el-checkbox>
            </el-option>
            <el-option
              :key="item.id"
              :label="item.name"
              :value="item.code"
              v-for="item in pointList">
            </el-option>
          </el-select>
        </el-col>
        <el-col :lg="3" :md="3" :sm="24" :xl="7" :xs="24" style="line-height: 28px;text-align: right;">
          <el-button :loading="selectDownload" @touchstart.native="filtrateForm" @click.native="filtrateForm" size="mini" class="queryButton"
                     style="margin-bottom: 5px;margin-left:10px;font-weight:bold;padding:9px 25px;color:rgba(7, 230, 248, 1);">
            查询
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-row>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24" style="">
          <el-button @touchstart="openCustomReport" @click="openCustomReport" class="button"
                   size="mini" style="float: right; margin-bottom: 10px; margin-right: 10px; height: 30px;">
                   <img src="@/assets/images/icon/excel.png" style="margin-bottom: 4px;">
            <span style="margin-left: 5px;color: #299FFB">自定义报表</span>
          </el-button>
          
          <!-- <el-button :loading="isDownload" @touchstart="exportExcel" @click="exportExcel" class="button"
                   size="mini" style="float: right; margin-bottom: 10px;height: 30px;">
            <iframe frameborder="0" ref="downExcel" style="display:none"></iframe>
            <img src="@/assets/images/icon/excel.png" style="margin-bottom: 4px;">
            <span style="margin-left: 5px;color: #299FFB">导出</span>
          </el-button> -->
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        height="55vh"
        border
        style="width: 100%;">
        <el-table-column
          prop="deviceName"
          align="center"
          label="设备名称">
        </el-table-column>
        <el-table-column
          align="center"
          label="区域"
          prop="spaceName"
          width="170">
        </el-table-column>
        <el-table-column
          align="center"
          label="主机"
          prop="gatewayName"
          width="170">
        </el-table-column>
        <el-table-column
          align="center"
          label="测点"
          prop="pointName">
        </el-table-column>
        <el-table-column
          align="center"
          label="值"
          prop="pointValue">
        </el-table-column>
        <el-table-column
          align="center"
          label="可视数值"
          prop="pointValueName">
        </el-table-column>
        <el-table-column
          align="center"
          label="日期"
          prop="commitTime"
          width="170">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="margin-top: 15px;text-align: center;" v-if="tableData">
      <el-pagination
        background
        layout="prev, next"
        :current-page.sync="defaultForm.pageCurrent"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-row>
    
    <!-- 使用自定义报表抽屉组件 -->
    <custom-report-dialog 
      v-model="customReportVisible"
      :initial-data="customReportInitialData"
      @submit="handleCustomReportSubmit"
      @cancel="handleCustomReportCancel"
    />
  </div>
</template>

<script>
import CustomReportDialig from './CustomReportDialig.vue';
import {dataList, pointHistoryExportToExcel} from "@/network/measuring-point-history";
import {userDevice} from "@/network/device-info";
import {getSpaceTreeData, getTreeHaveDisabled} from "@/network/space-info";
import {listByDeviceIdList} from "@/network/device-measuring-point";
import './style.css'

export default {
  name: "HistoricalData",
  components: {
    'custom-report-dialog': CustomReportDialig
  },
  data() {
    return {
      options: [],
      isDownload: false,
      selectDownload: false,
      // 空间树
      spaceTree: [{
        value: '',
        label: ''
      }],
      deviceIds:[],
      defaultForm: {
        deviceName: [],
        pageSize: 10,
        pageCurrent: 1,
        startTime: '',
        endTime: '',
        spaceId: '',
        spaceIds: [],
      },
      pointList:[],
      value: '',
      value2: [],
      tableData: [],
      dateTotal: 0,
      // 时间选择器绑定值
      screenDate: '',
      // 自定义报表相关数据
      customReportVisible: false,
      customReportInitialData: {},
      isAllSelected: false,
      isIndeterminate: false,
      // 测点全选相关状态
      isAllPointsSelected: false,
      isPointsIndeterminate: false
    }
  },
  watch: {
    'defaultForm.spaceIds': {
      handler(val) {
        if (val.length > 0) {
          this.defaultForm.spaceId = val[val.length - 1]
          // 初始化设备
          this.getUserDevice();
        } else {
          this.defaultForm.spaceId = ''
          this.options = []
          this.deviceIds=[]
          this.defaultForm.deviceName = []
        }
      }
    },
    deviceIds: {
      handler(val) {
        const checkedCount = val.length;
        this.isAllSelected = checkedCount === this.options.length && this.options.length > 0;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
      },
      deep: true
    },
    options: {
      handler() {
        const checkedCount = this.deviceIds.length;
        this.isAllSelected = checkedCount === this.options.length && this.options.length > 0;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
      },
      deep: true
    },
    // 监听测点列表变化
    pointList: {
      handler() {
        const checkedCount = this.defaultForm.pointCodes.length;
        this.isAllPointsSelected = checkedCount === this.pointList.length && this.pointList.length > 0;
        this.isPointsIndeterminate = checkedCount > 0 && checkedCount < this.pointList.length;
      },
      deep: true
    },
    // 监听选中测点变化
    'defaultForm.pointCodes': {
      handler(val) {
        const checkedCount = val.length;
        this.isAllPointsSelected = checkedCount === this.pointList.length && this.pointList.length > 0;
        this.isPointsIndeterminate = checkedCount > 0 && checkedCount < this.pointList.length;
      },
      deep: true
    }
  },
  mounted() {
    this.getSpaceTreeData();
    this.getData(this.defaultForm);
  },
  methods: {
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          this.spaceTree = getTreeHaveDisabled(res.data);
        }
      });
    },
    // 全选
    checkAll(val) {
      this.isIndeterminate = false;
      if (val) {
        this.deviceIds = this.options.map(item => item.id);
      } else {
        this.deviceIds = [];
      }
      // 获取测点数据
      this.getPointList();
    },
    // excel导出
    exportExcel() {
      this.isDownload = true;
      let form = this.defaultForm;
      if (!form.startTime || !form.endTime) {
        this.$message.error("请选择导出的时间范围");
        this.isDownload = false;
        return false;
      }
      this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      pointHistoryExportToExcel(form).then(res => {
        this.isDownload = false
        if (res.code === 0) {
          let iframe = this.$refs.downExcel;
          const href = window.g.ftpUrl + res.data;//接口路径地址，返回数据类型为application/binary，后台控制显示信息，前端仅为下载功能
          iframe.src = href
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        console.log(err);
        this.isDownload = false;
        this.$message.error("下载失败");
      });
    },
    // 获取数据
    getData(params) {
      this.selectDownload = true;
      dataList(params).then(res => {
        this.selectDownload = false;
        this.tableData = res.data;
        if (res.code === 0) {
          if (!res.data && this.defaultForm.pageCurrent !== 1) {
            this.defaultForm.pageCurrent = 1;
          }
        }
      });
    },
    // 获取数据
    getUserDevice() {
      userDevice(this.defaultForm.spaceId).then(res => {
        if (res.code === 0) {
          let result = [];
          let obj = {};
          for (var i = 0; i < res.data.length; i++) {
            if (!obj[res.data[i].name]) {
              result.push(res.data[i]);
              obj[res.data[i].name] = true;
            }
          }
          this.options = result;
        }
      });
    },
    // 获取测点数据
    getPointList() {
      if (this.deviceIds.length === 0) {
        this.pointList = [];
        this.defaultForm.deviceName = [];
        this.defaultForm.pointCodes = [];
      }
      
      this.defaultForm.deviceName = this.deviceIds.map(id => {
        return this.options.find(device => device.id === id).name;
      });

      // 筛选出设备的id列表
      listByDeviceIdList(this.deviceIds).then(res => {
        if (res.code === 0) {
          this.pointList = res.data;
        }
      });
    },
    // 翻页
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.defaultForm.pageCurrent = val;
      this.getData(this.defaultForm);
    },
    // 查询
    filtrateForm() {
      this.selectDownload = true;
      // 获取选择的设备
      // 设置开始时间
      if (this.screenDate != null && this.screenDate.length > 0) {
        let startTime = this.screenDate[0];
        let endTime = this.screenDate[1];
        console.log(this.screenDate)

        this.defaultForm.startTime = startTime;
        // 设置结束时间
        this.defaultForm.endTime = endTime;
      } else {
        this.defaultForm.startTime = '';
        // 设置结束时间
        this.defaultForm.endTime = '';
      }
      this.defaultForm.pageCurrent = 1;
      this.getData(this.defaultForm);
    },
    // 打开自定义报表抽屉
    openCustomReport() {
      this.customReportVisible = true;
    },
    
    // 处理自定义报表提交
    handleCustomReportSubmit(formData) {
      console.log('生成自定义报表:', formData);
      this.$message.success('正在生成自定义报表，请稍候...');
      
      // 这里可以添加生成报表的逻辑
      // ...
    },
    
    // 处理自定义报表取消
    handleCustomReportCancel() {
      console.log('取消自定义报表');
    },
    // 处理设备选择变化
    handleSelectChange(val) {
      // 检查是否选择了全选选项
      const allOptionIndex = val.indexOf('all');
      if (allOptionIndex > -1) {
        // 移除全选选项
        val.splice(allOptionIndex, 1);
        
        // 根据当前全选状态切换
        if (!this.isAllSelected) {
          // 如果当前不是全选，则全选
          this.isAllSelected = true;
          this.isIndeterminate = false;
          this.deviceIds = this.options.map(item => item.id);
        } else {
          // 如果当前是全选，则取消全选
          this.isAllSelected = false;
          this.isIndeterminate = false;
          this.deviceIds = [];
        }
      } else {
        console.log(val, 'val');
        // 正常更新全选状态
        this.deviceIds = val;
      }
      
      // 获取测点数据
      this.getPointList();
    },
    // 测点全选
    checkAllPoints(val) {
      this.isPointsIndeterminate = false;
      if (val) {
        this.defaultForm.pointCodes = this.pointList.map(item => item.code);
      } else {
        this.defaultForm.pointCodes = [];
      }
    },
    // 处理测点选择变化
    handlePointSelectChange(val) {
      // 检查是否选择了全选选项
      const allOptionIndex = val.indexOf('all');
      if (allOptionIndex > -1) {
        // 移除全选选项
        val.splice(allOptionIndex, 1);
        
        // 根据当前全选状态切换
        if (!this.isAllPointsSelected) {
          // 如果当前不是全选，则全选
          this.isAllPointsSelected = true;
          this.isPointsIndeterminate = false;
          this.defaultForm.pointCodes = this.pointList.map(item => item.code);
        } else {
          // 如果当前是全选，则取消全选
          this.isAllPointsSelected = false;
          this.isPointsIndeterminate = false;
          this.defaultForm.pointCodes = [];
        }
      } else {
        // 正常更新选中值
        this.defaultForm.pointCodes = val;
      }
    }
  }
}
</script>

<style scoped>

::v-deep .el-button:hover {
  background-color: rgba(41, 155, 255, .4) !important;
  color: #fff;
}
.queryButton{
  background-color: rgba(41, 155, 255, .2) !important;
}
</style>
